import { render, staticRenderFns } from "./getproinfo-form.vue?vue&type=template&id=78dc81bc&scoped=true&"
import script from "./getproinfo-form.vue?vue&type=script&lang=js&"
export * from "./getproinfo-form.vue?vue&type=script&lang=js&"
import style0 from "./getproinfo-form.vue?vue&type=style&index=0&id=78dc81bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc81bc",
  null
  
)

export default component.exports